var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M136.534,376a.534.534,0,0,0-.533-.533H120a.533.533,0,1,0,0,1.067h16A.534.534,0,0,0,136.534,376Z",
    transform: "translate(-112 -352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M330.667,208.533v-3.2a.534.534,0,0,0-.533-.533H324.8a.534.534,0,0,0-.533.533v3.2a.534.534,0,0,0,.533.533h5.333A.533.533,0,0,0,330.667,208.533ZM329.6,208h-4.267v-2.133H329.6Z",
    transform: "translate(-304 -192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M29.947,362.667l1.982-3.469a.533.533,0,0,0-.463-.8H26.133a.534.534,0,0,0-.533.533v8H6.4v-8a.534.534,0,0,0-.533-.533H.533a.533.533,0,0,0-.463.8l1.982,3.469L.07,366.135a.533.533,0,0,0,.463.8h3.2a.533.533,0,0,0,0-1.067H1.452l1.677-2.935a.532.532,0,0,0,0-.529l-1.677-2.935H5.333v8a.534.534,0,0,0,.533.533H26.133a.534.534,0,0,0,.533-.533v-8h3.881L28.87,362.4a.532.532,0,0,0,0,.529l1.677,2.935H28.266a.533.533,0,0,0,0,1.067h3.2a.533.533,0,0,0,.463-.8Z",
    transform: "translate(0 -336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M51.2,35.2a1.067,1.067,0,1,0,1.067-1.067A1.068,1.068,0,0,0,51.2,35.2Z",
    transform: "translate(-48 -32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M.533,6.4h28.8a.533.533,0,1,0,0-1.067H1.067V2.667a1.6,1.6,0,0,1,1.6-1.6H29.333a1.6,1.6,0,0,1,1.6,1.6V20.8A.533.533,0,1,0,32,20.8V2.667A2.67,2.67,0,0,0,29.333,0H2.667A2.67,2.67,0,0,0,0,2.667v3.2A.534.534,0,0,0,.533,6.4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M153.6,35.2a1.067,1.067,0,1,0,1.067-1.067A1.068,1.068,0,0,0,153.6,35.2Z",
    transform: "translate(-144 -32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M102.4,35.2a1.067,1.067,0,1,0,1.067-1.067A1.068,1.068,0,0,0,102.4,35.2Z",
    transform: "translate(-96 -32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M.533,133.334a.534.534,0,0,0,.533-.533V120A.533.533,0,0,0,0,120v12.8A.534.534,0,0,0,.533,133.334Z",
    transform: "translate(0 -112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M344,137.6a.533.533,0,0,0,0-1.067h-2.133a.533.533,0,0,0,0,1.067Z",
    transform: "translate(-320.001 -128.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M204.8,205.333v3.2a.534.534,0,0,0,.533.533h5.333a.534.534,0,0,0,.533-.533v-3.2a.534.534,0,0,0-.533-.533h-5.333A.534.534,0,0,0,204.8,205.333Zm1.067.533h4.267V208h-4.267Z",
    transform: "translate(-192 -192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M275.734,137.6a.533.533,0,0,0,0-1.067H273.6a.533.533,0,1,0,0,1.067Z",
    transform: "translate(-256 -128.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M338.133,290.667a.533.533,0,0,0-.533-.533h-4.267a.533.533,0,1,0,0,1.067H337.6A.534.534,0,0,0,338.133,290.667Z",
    transform: "translate(-312 -272.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M213.867,290.133a.533.533,0,0,0,0,1.067h4.267a.533.533,0,0,0,0-1.067Z",
    transform: "translate(-200.001 -272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M85.867,209.068H91.2a.534.534,0,0,0,.533-.533v-3.2a.534.534,0,0,0-.533-.533H85.867a.534.534,0,0,0-.533.533v3.2A.533.533,0,0,0,85.867,209.068Zm.533-3.2h4.267V208H86.4Z",
    transform: "translate(-80.001 -192.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M94.4,291.2h4.267a.533.533,0,0,0,0-1.067H94.4a.533.533,0,0,0,0,1.067Z",
    transform: "translate(-88 -272.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M412.8,137.067a.534.534,0,0,0-.533-.533h-2.133a.533.533,0,1,0,0,1.067h2.133A.534.534,0,0,0,412.8,137.067Z",
    transform: "translate(-384.001 -128.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M56.533,137.067a.534.534,0,0,0-.533-.533H51.733a.533.533,0,0,0,0,1.067H56A.534.534,0,0,0,56.533,137.067Z",
    transform: "translate(-48 -128.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M362.933,87.243l.514,1.043,1.152.168-.833.812.2,1.147-1.03-.542-1.03.542.2-1.147-.833-.812,1.151-.168Z",
    transform: "translate(-352.645 -61.155)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M362.933,87.243l.514,1.043,1.152.168-.833.812.2,1.147-1.03-.542-1.03.542.2-1.147-.833-.812,1.151-.168Z",
    transform: "translate(-347.645 -61.155)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M362.933,87.243l.514,1.043,1.152.168-.833.812.2,1.147-1.03-.542-1.03.542.2-1.147-.833-.812,1.151-.168Z",
    transform: "translate(-342.645 -61.155)",
    stroke: "#fff",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.d697e235558ee9ea9cf715bd916f1b80.svg";
export { ForwardRef as ReactComponent };